module.exports = __webpack_public_path__ + "img/aqfh-img-13.ed196109.png";